import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./themes.css";
import App from "./App";
import { registerServiceWorker } from "./lib/registerSW";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
